import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

export default function OrganizationRedirect() {
  const location = useLocation();
  const queryParams = location.search;

  const redirectUrl = `/organizations/${localStorage.getItem(
    'currentOrganizationId'
  )}/settings${queryParams}`;

  return <Redirect to={redirectUrl} />;
}
